module.exports = __webpack_public_path__ + "static/media/qualiss_logo_resized.5298008d.PNG";